<!--询价中心-->
<template>
  <div class="enquiryCenter">
    <div :style="enquiryStyle">
      <div class="top">
        <div class="enquirydiv">
          <span class="e1">{{name}}</span>
          <br />
          <span class="e2">{{about}}</span>
          <br />
          <a class="in-enquiry" href="#" @click="jumpToList(url)">{{come}}</a>
        </div>
      </div>
    </div>
    <div class="enquiry-content">
      <div class="enquiry-title">
        <span class="title-type">{{state}}</span>
        <span class="center-title">{{inquirytitle}}</span>
        <span class="organize">{{puborg}}</span>
        <span class="publish-time">{{pubdate}}</span>
      </div>
      <div class="enquiry-border-bottom"></div>
      <div class="enquiry-list">
        <ul>
          <li v-for="(category,i) in categorys.slice(0,5)" :key="i">
            <a href="#" @click="jumpToDetail(category.noticeId)">
              <span
                class="status"
                :title="category.status.value"
                :class="addclassStatus(category.status.num)"
              >{{category.status.value}}</span>
              <span class="title-content" :title="category.noticeName">{{category.noticeName}}</span>
              <span class="organize-content">{{category.org}}</span>
              <span class="time-content">{{category.publish_time.substring(0,11)}}</span>
            </a>
          </li>
        </ul>
        <div class="tender-a">
          <a href="#" @click="showbut" :style="tender">{{moreview}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import axios from '@/utils/http'; // 导入http中创建的axios实例

export default {
  data() {
    //常量
    // let constant = JSON.parse(this.$supMainPageConfig).constant;
    // this.theme = JSON.parse(this.$supMainPageConfig).catItemImg.info7.theme;
    // let categoryInfo1 = JSON.parse(this.$supMainPageConfig).categoryInfoShow
    //   .categoryInfo1[1];
    return {
      // moreview: constant.moreview,
      // state: constant.state,
      // inquirytitle: constant.inquirytitle,
      // puborg: constant.puborg,
      // pubdate: constant.pubdate,
      // name: categoryInfo1.category.name,
      // about: JSON.parse(this.$supMainPageConfig).catItemImg.info2.about,
      // come: categoryInfo1.category.come,
      // url: categoryInfo1.category.url,
      // categorys: categoryInfo1.info,
      // biztype: categoryInfo1.biztype,
      show: false,
      //showT: this.theme,
      enquiryshow: false
    };
  },
  methods: {
    jumpToDetail(noticeId) {
      let param = "";
      param = "&noticeId=" + noticeId + "&noticeName=quo_inquiry";
      const base = axios.defaults.baseURL;
      let url = base + "/index.html?formId=quo_notice" + param;
      window.open(url, "_blank");
    },
    jumpToList(link) {
      window.open(link, "_blank");
    },
    showbut() {
      this.$emit("funcc", this.show);
    },
    addclassStatus(status) {
      switch (status) {
        case "10":
          return "statustypea";
        case "11":
          return "statustypeb";
        case "12":
          return "statustypec";
        case "13":
          return "statustyped";
        case "14":
          return "statustypee";
        case "15":
          return "statustypef";
      }
    }
  },
  computed: {
        //store里面取数据
    ...mapGetters(['supMainPageConfig']),
  moreview: function()  {
      return JSON.parse(this.supMainPageConfig).constant.moreview;
    },
  state: function()  {
      return JSON.parse(this.supMainPageConfig).constant.state;
    },
  inquirytitle: function()  {
      return JSON.parse(this.supMainPageConfig).constant.inquirytitle;
    },
  puborg: function()  {
      return JSON.parse(this.supMainPageConfig).constant.puborg;
    },
  pubdate: function()  {
      return JSON.parse(this.supMainPageConfig).constant.pubdate;
    },
  name: function()  {
      return JSON.parse(this.supMainPageConfig).categoryInfoShow
      .categoryInfo1[1].category.name;
    },

  about: function()  {
      return JSON.parse(this.supMainPageConfig).catItemImg.info2.about;
    },
 
  come: function()  {
        return JSON.parse(this.supMainPageConfig).categoryInfoShow
      .categoryInfo1[1].category.come;
    },

  url: function()  {
       return JSON.parse(this.supMainPageConfig).categoryInfoShow
      .categoryInfo1[1].category.url;
    },
  categorys: function()  {
        return JSON.parse(this.supMainPageConfig).categoryInfoShow
      .categoryInfo1[1].info;
    },
    
  biztype: function()  {
     return JSON.parse(this.supMainPageConfig).categoryInfoShow
      .categoryInfo1[1].biztype;
    },

  showT: function()  {
      return JSON.parse(this.supMainPageConfig).catItemImg.info7.theme;
    },
 



 enquiryStyle: function() {
      let enquiryConfig = JSON.parse(this.supMainPageConfig).catItemImg.info2
        .enquiryImgSrc;
      return {
        backgroundImage: "url(" + enquiryConfig + ")",
        backgroundRepeat: "no-repeat",
        width: "100%",
        height: "220px",
        backgroundSize: "100% 100%"
      };
    },
    tender: function() {
      if (this.showT == 1) {
        return {
          color: " #4a98ff",
          textDecoration: "none",
          fontSize: "14px",
          marginRight: "22px",
          float:"right"
        };
      }
      if (this.showT == 2) {
        return {
          color: " #6869FB",
          textDecoration: "none",
          fontSize: "14px",
          marginRight: "22px",
          float:"right"
        };
      }
      if (this.showT == 3) {
        return {
          color: " #29C392",
          textDecoration: "none",
          fontSize: "14px",
          marginRight: "22px",
          float:"right"
        };
      }
      if (this.showT == 4) {
        return {
          color: " #FC8555",
          textDecoration: "none",
          fontSize: "14px",
          marginRight: "22px",
          float:"right"
        };
      }
    }
  },
  props: ["enquiryshow"]
};
</script>

<style scoped lang="scss">
.enquirydiv {
  width: 1200px;
  margin: 0 auto;
}
.enquiryCenter {
  width: 100%;
  margin: 0 auto;
  margin-top: 64px;
}
.top {
  padding-top: 16px;
}
.top .e1 {
  height: 56px;
  font-size: 40px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 56px;
  letter-spacing: 2px;
}
.top .e2 {
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
}
.top .in-enquiry {
  display: inline-grid;
  margin-top: 22px;
  //width: 126px;
  width: 160px;
  height: 32px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(107, 110, 131, 1);
  line-height: 32px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  border-radius: 4px;
  border: 0px;
  text-align: center;
  text-decoration: none;
}
.enquiry-content {
  width: 1200px;
  height: 347px;
  background: #ffffff;
  margin: 0 auto;
  margin-top: -50px;
  border-radius: 5px;
}
.enquiry-title {
  margin-left: 24px;
  padding-top: 26px;
  display: flex; // ---
}
.enquiry-title span:not(.title-type) { // ---
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
  letter-spacing: 1px;
  font-weight: bold;
  flex: 1;// ---
}
.enquiry-content .enquiry-title span.title-type {
  display: inline-block; // ---
  width: 96px; // ---
  margin-right: 66px; // ---
  font-weight: 700;
}
.enquiry-title span.center-title {
  //margin-left: 30px;
  // margin-left: 150px; // ---
}
.enquiry-title span.organize {
  //margin-left: 504px;
  // margin-left: 250px; // ---
}

.enquiry-title span.publish-time {
 //margin-left: 358px;
//  margin-left: 255px; // ---
}


.enquiry-border-bottom {
  margin-left: 24px;
  margin-right: 22px;
  margin-top: 22px;
  border-top: 1px solid #dadada;
}
.enquiry-list ul {
  list-style: none;
  padding-left: 24px;
}
.enquiry-list ul li a {
  color: inherit;
  text-decoration: none;
  display: flex; // ---
}

.enquiry-list ul li a:hover {
  background-color: #f2f6fc;
}

.enquiry-list img {
  width: 45px;
  height: 18px;
  align-items: center;
  margin-right: 12px;
  vertical-align: sub;
}
.enquiry-list ul li {
  height: 22px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(41, 44, 64, 1);
  line-height: 22px;
  margin-bottom: 22px;
}

//状态类型
.enquiry-list ul li .status {
  color: rgb(74, 152, 255);
  border: 1px solid rgb(74, 152, 255);
  margin-right: 60px; // ---
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 96px; // ---
}

.enquiry-list ul li .title-content {
  // width: 495px; // ---
  // padding-right: 74px; // ---
  //display: inline-block;
  max-width: 495px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1; // ---
  //margin-left: 12px;
  // margin-left: 115px; // ---
}

.enquiry-list ul li .organize-content {
  // width: 274px; // ---
  // padding-right: 150px; // ---
  //display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex:  1;// ---
  //间距
  // margin-left: -260px; // ---
}
//时间格式
.enquiry-list ul li .time-content {
  // width: 127px; // ---
  // display: inline-block; // ---
  // margin-left: -110px; // ---
  flex: 1;// ---
}


.statustypea {
  color: #29c392;
  border: 1px solid #29c392;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypeb {
  color: rgb(74, 152, 255);
  border: 1px solid rgb(74, 152, 255);
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypec {
  color: #778899;
  border: 1px solid #778899;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustyped {
  color: #778899;
  border: 1px solid #778899;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypee {
  color: #fc8555;
  border: 1px solid #fc8555;
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

.statustypef {
  color: rgb(74, 152, 255);
  border: 1px solid rgb(74, 152, 255);
  margin-right: 12p;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 10px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  width: 54px;
}

@media screen and ( max-width: 1200px ){
  .enquirydiv {
  width: 900px;
}
.enquiry-content {
  width: 900px;
}

.enquiry-title span.publish-time {
  margin-left: 255px;
  
}

.enquiry-title span.organize {
  margin-left: 250px;
 //margin-left: 329px;
}

.enquiry-list ul li .title-content {
  width: 309px;
}
.enquiry-list ul li .organize-content {
  width: 174px;
}
}

</style>